module.exports = "/packs/images/sprites/facilities~cc51c0cb2d67cec43584778b3470b020.svg";